import React from 'react';

import { RovoHexIcon } from '@atlaskit/logo/rovo-hex/icon';
import { Box } from '@atlaskit/primitives/compiled/box';
import Tile from '@atlaskit/tile/tile';

export type RovoTileIconProps = {
	/** Match the third-party logos alongside it. Only the sizes in use are offered. */
	size: 'xxsmall' | 'xsmall' | 'small';
};

/**
 * The Rovo mark in the bordered tile `logo-third-party` gives its own logos, so the two read as
 * one set wherever they sit together. No Rovo variant carries its own tile — those that do are a
 * different product (Rovo Dev) or the pre-rebrand logo.
 *
 * `white` because the brand mark does not adapt to dark mode either: both of `IconWrapper`'s
 * appearance maps resolve its colours to `initial`.
 */
export function RovoTileIcon({ size }: RovoTileIconProps): React.JSX.Element {
	return (
		<Tile backgroundColor="white" hasBorder label="" size={size}>
			{/*
			 * `lineHeight: 0` is what lets the tile's inset size the mark. `IconWrapper` renders an
			 * inline-block span, so its svg sits on a text baseline; under the inset's `height: auto`
			 * the span grows by the font's descender and the mark centres high. It rides the `style`
			 * prop because `cssMap` rejects the property outright.
			 */}
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- lineHeight: 0 is a layout fix collapsing the inline baseline gap under IconWrapper's <span>, not a typography choice. */}
			<Box as="span" style={{ lineHeight: 0 }}>
				<RovoHexIcon label="" size={size} />
			</Box>
		</Tile>
	);
}
